export const ThreeStars = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.13495 14.4151L6.17396 12.2121C6.30734 11.9293 6.69266 11.9293 6.82604 12.2121L7.86505 14.4151L10.1886 14.7706C10.4867 14.8162 10.6055 15.1997 10.3897 15.4198L8.7087 17.1334L9.10542 19.5543C9.15636 19.8652 8.84456 20.1022 8.57781 19.9554L6.5 18.8118L4.42219 19.9554C4.15544 20.1022 3.84363 19.8652 3.89458 19.5543L4.2913 17.1334L2.6103 15.4198C2.39447 15.1997 2.51329 14.8162 2.81141 14.7706L5.13495 14.4151Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1349 14.4151L18.174 12.2121C18.3073 11.9293 18.6927 11.9293 18.826 12.2121L19.8651 14.4151L22.1886 14.7706C22.4867 14.8162 22.6055 15.1997 22.3897 15.4198L20.7087 17.1334L21.1054 19.5543C21.1564 19.8652 20.8446 20.1022 20.5778 19.9554L18.5 18.8118L16.4222 19.9554C16.1554 20.1022 15.8436 19.8652 15.8946 19.5543L16.2913 17.1334L14.6103 15.4198C14.3945 15.1997 14.5133 14.8162 14.8114 14.7706L17.1349 14.4151Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1349 5.41515L12.174 3.21211C12.3073 2.9293 12.6927 2.9293 12.826 3.21211L13.8651 5.41515L16.1886 5.7706C16.4867 5.8162 16.6055 6.19974 16.3897 6.41976L14.7087 8.13337L15.1054 10.5543C15.1564 10.8652 14.8446 11.1022 14.5778 10.9554L12.5 9.81178L10.4222 10.9554C10.1554 11.1022 9.84363 10.8652 9.89458 10.5543L10.2913 8.13337L8.6103 6.41976C8.39447 6.19974 8.51329 5.8162 8.81141 5.7706L11.1349 5.41515Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
